import React, { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import Topbar from "../sidebar/topbar";
import { LoadingState } from "../components/ui/States";

const PIN_KEY = "sidebarPinned";

function readPinned() {
  try {
    return localStorage.getItem(PIN_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Persistent app shell for authenticated pages: sidebar + topbar mount once and
 * survive navigation; only the routed page inside <Outlet /> changes.
 */
export default function AppLayout() {
  const [isPinned, setIsPinned] = useState(readPinned);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer and reset scroll on navigation
  useEffect(() => {
    setIsMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const togglePinned = () => {
    setIsPinned((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(PIN_KEY, String(next));
      } catch {
        /* storage unavailable - keep in-memory state */
      }
      return next;
    });
    setIsHovered(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        isPinned={isPinned}
        onTogglePinned={togglePinned}
        isHovered={isHovered}
        onHoverChange={setIsHovered}
        isMobileOpen={isMobileOpen}
        onMobileClose={() => setIsMobileOpen(false)}
      />

      {/* Content margin follows the pinned state only, so hover-expanding never shifts the page */}
      <div className={`flex flex-col min-h-screen min-w-0 transition-[margin] duration-200 ${isPinned ? "md:ml-64" : "md:ml-16"}`}>
        <Topbar onMenuToggle={() => setIsMobileOpen((open) => !open)} />
        <main className="flex-1 min-w-0 p-3 sm:p-4 md:p-6">
          <Suspense fallback={<LoadingState />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
